module.exports = __webpack_public_path__ + "img/newswiper_3.e84d1304.png";